module.exports = __webpack_public_path__ + "img/5s.cfc290c1.png";